import template from './DimensionFilterView.html';
import { EventEmitter } from 'modules/shared/EventEmitter';
import { UserProperties } from 'modules/application/detail/users/models/UserProperties';
import './dimensionFilter.scss';
import { ODataOperator, ODataFunction, } from 'types/OData';
import { UserFeatures } from 'modules/application/detail/users/UserFeatures';
class DimensionFilterController {
    static $inject = ['$translate', 'TranslateService'];
    constructor($translate, TranslateService) {
        'ngInject';
        this.$translate = $translate;
        this.TranslateService = TranslateService;
        this.isContactTaxDocumentEnabled = false;
        this.onInit();
    }
    async onInit() {
        await this.checkFeatures();
        this.setProperties();
        this.mapUserProperties();
        await this.loadComparisons();
    }
    setProperties() {
        this.props = this.isContactTaxDocumentEnabled
            ? UserProperties.getPropsWithDocument()
            : UserProperties.getProps();
    }
    mapUserProperties() {
        this.userProperties = this.props.map(key => ({
            key,
            name: this.TranslateService.instantTranslate(`utils.forms.${key}`),
        }));
    }
    async checkFeatures() {
        this.isUsingStartsWithOnContactsSearch = await UserFeatures.isUsingStartsWithOnContactsSearch();
        this.isContactTaxDocumentEnabled = await UserFeatures.isContactTaxDocumentEnabled();
        this.isReactOnDimensionFilterEnabled = await UserFeatures.isReactOnContactsPageEnabled();
    }
    get isNotValidValue() {
        return this.data.property && !this.data.value;
    }
    get isNotValidProperty() {
        return !this.data.property && this.data.value;
    }
    async loadComparisons() {
        this.comparisons = this.isUsingStartsWithOnContactsSearch
            ? [
                {
                    value: ODataFunction.StartsWith,
                    label: await this.$translate('utils.misc.odata.startsWith'),
                },
            ]
            : [
                {
                    value: ODataFunction.Contains,
                    label: await this.$translate('utils.misc.odata.contains'),
                },
                {
                    value: ODataFunction.NotContains,
                    label: await this.$translate('utils.misc.odata.notContain'),
                },
            ];
        const propertyIsOnList = this.props.indexOf(this.data.prop) !== -1;
        if (propertyIsOnList) {
            this.comparisons = this.comparisons.concat({
                value: ODataOperator.Equals,
                label: await this.$translate('utils.misc.odata.equals'),
            });
            this.comparisons = this.comparisons.concat({
                value: ODataOperator.NotEquals,
                label: await this.$translate('utils.misc.odata.notEqual'),
            });
        }
    }
    handleChanges(changes) {
        this.loadComparisons();
        if (this.onChanges) {
            this.onChanges(EventEmitter({ changes }));
        }
    }
}
DimensionFilterController.$inject = ['$translate', 'TranslateService'];
export const DimensionFilterComponent = {
    template,
    controller: DimensionFilterController,
    controllerAs: '$ctrl',
    bindings: {
        data: '<',
        onChanges: '&?',
        conditionDisabled: '<?',
    },
};
